import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createRoom, joinRoom } from "./mainThunk";
import { EStages } from "../../utils/types";
import { setupWebSocket } from "../../socket/socket";

type TResultTable = Array<[string, number]>;

export interface IMainState {
  roomId: string | null;
  isAdmin: boolean;
  nickname: string | null;
  userId: string | null;
  stage: EStages | null;
  allUsers: string[];
  songs: string[];
  chosenUser: null | string;
  voteSong: null | string;
  resultTable: TResultTable | null;
  loading: boolean;
  errors: string;
}

const initialState: IMainState = {
  roomId: null,
  isAdmin: false,
  nickname: null,
  userId: null,
  stage: null,
  allUsers: [],
  songs: [],
  chosenUser: null,
  voteSong: null,
  resultTable: null,
  loading: false,
  errors: "",
}

const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setErrors: (state, { payload }: PayloadAction<string>) => {
      state.errors = payload;
    },
    setNickname: (state, { payload }: PayloadAction<string>) => {
      state.nickname = payload;
    },
    setLobbyStage: (state, { payload }: PayloadAction<{stage: EStages, user_names: string[]}>) => {
      state.stage = payload.stage;
      state.allUsers = payload.user_names;
    },
    setAddSongs: (state, { payload }: PayloadAction<{stage: EStages, songs: string[]}>) => {
      state.stage = payload.stage;
      state.songs = payload.songs;
    },
    setVoteStage: (state, { payload }: PayloadAction<{stage: EStages, users: string[], chosen_user: string, song: string}>) => {
      state.stage = payload.stage;
      state.allUsers = payload.users;
      state.chosenUser = payload.chosen_user;
      state.voteSong = payload.song;
    },
    setResultsStage: (state, { payload }: PayloadAction<{stage: EStages, result_table: TResultTable}>) => {
      state.stage = payload.stage;
      state.resultTable = payload.result_table;
    },
    setIsAdmin: (state, {payload}: PayloadAction<boolean>) => {
      state.isAdmin = payload;
    },
    setUserId: (state, {payload}: PayloadAction<string>) => {
      state.userId = payload;
    },
    setChosenUser: (state, {payload}: PayloadAction<string>) => {
      state.chosenUser = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createRoom.fulfilled, (state, action) => {
      state.roomId = action.payload.room_id;
      state.userId = action.payload.admin_id;
      state.isAdmin = true;
      setupWebSocket(action.payload.room_id, action.payload.admin_id, true);
    })
    builder.addCase(joinRoom.fulfilled, (state, action) => {
      state.userId = action.payload.user_id;
      state.isAdmin = false;
      setupWebSocket(action.payload.room_id, action.payload.user_id, false);
    })
  },
})

export const { setLoading, setErrors, setNickname, setLobbyStage, setAddSongs, setVoteStage, setResultsStage, setIsAdmin, setUserId, setChosenUser } = mainSlice.actions

export const mainSliceReducer = mainSlice.reducer;

export const mainsSelector = (state: { mainsStore: IMainState }) =>
  state.mainsStore